import issuedLoan from './issued-loan.js';
import receivedLoan from './received-loan.js';

export default [...issuedLoan, ...receivedLoan];
